module.exports = __webpack_public_path__ + "static/media/flightboard.253cd702.png";